












import {Component, Prop, Vue} from "vue-property-decorator";
@Component
export default class Id extends Vue {
    @Prop({default:"12"}) md!:string;
    @Prop({}) value!:string;
    updateValue (value:string) {
        this.$emit('input', value)
    }
}
